/* Van Straaten Mode — theme.js */
(function () {
  'use strict';
  const T = window.theme || {};
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const overlay = $('[data-overlay]');
  let openLayer = null;

  /* ---------- Geldformaat ---------- */
  function formatMoney(cents, format) {
    format = format || T.moneyFormat || '€{{amount_with_comma_separator}}';
    const value = (Number(cents) || 0) / 100;
    const fmt = (n, dec, thou, decSep) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(decSep);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount': return fmt(value, 2, ',', '.');
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_space_separator': return fmt(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmt(value, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        default: return fmt(value, 2, '.', ',');
      }
    });
  }

  /* ---------- Lagen (drawer, menu, filters) ---------- */
  function openPanel(el) {
    if (!el) return;
    if (openLayer && openLayer !== el) closePanel(openLayer, true);
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('is-visible'));
    document.body.classList.add('is-locked');
    document.body.classList.toggle('mnav-open', el.hasAttribute('data-mnav'));
    openLayer = el;
  }
  function closePanel(el, keepOverlay) {
    el = el || openLayer;
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!keepOverlay) {
      overlay.classList.remove('is-visible');
      setTimeout(() => { if (!openLayer) overlay.hidden = true; }, 250);
      document.body.classList.remove('is-locked');
    }
    document.body.classList.remove('mnav-open');
    openLayer = null;
  }
  overlay && overlay.addEventListener('click', () => closePanel());
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (openLayer) closePanel();
    closeSearch();
    closeMega();
    $$('[data-modal]:not([hidden])').forEach((m) => (m.hidden = true));
    if (typeof closeQa === 'function') closeQa();
  });

  /* ---------- Aankondigingsbalk ---------- */
  $$('[data-announcement]').forEach((bar) => {
    const msgs = $$('.announcement__msg', bar);
    if (msgs.length < 2) return;
    let i = 0;
    const speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
    setInterval(() => {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, speed);
  });

  /* ---------- Megamenu ---------- */
  let megaTimer;
  function closeMega(except) {
    $$('[data-nav-item].is-open').forEach((li) => {
      if (li !== except) {
        li.classList.remove('is-open');
        const a = $('.nav__link', li); a && a.setAttribute('aria-expanded', 'false');
      }
    });
  }
  $$('[data-nav-item]').forEach((li) => {
    const link = $('.nav__link', li);
    const open = () => { clearTimeout(megaTimer); closeMega(li); li.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); };
    const close = () => { megaTimer = setTimeout(() => { li.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); }, 180); };
    li.addEventListener('mouseenter', () => { clearTimeout(megaTimer); megaTimer = setTimeout(open, 90); });
    li.addEventListener('mouseleave', close);
    link.addEventListener('click', (e) => {
      if (window.matchMedia('(hover: none)').matches && !li.classList.contains('is-open')) { e.preventDefault(); open(); }
    });
    link.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || (e.key === ' ' && !li.classList.contains('is-open'))) { e.preventDefault(); open(); const f = $('.mega a, .drop a', li); f && f.focus(); }
    });
    li.addEventListener('focusout', (e) => { if (!li.contains(e.relatedTarget)) close(); });
  });
  document.addEventListener('click', (e) => { if (!e.target.closest('[data-nav-item]')) closeMega(); });

  /* ---------- Mobiel menu ---------- */
  const mnav = $('[data-mnav]');
  $$('[data-mnav-open]').forEach((b) => b.addEventListener('click', () => openPanel(mnav)));
  $$('[data-mnav-close]').forEach((b) => b.addEventListener('click', () => closePanel(mnav)));

  /* ---------- Zoeken ---------- */
  const searchPanel = $('[data-search-panel]');
  const searchInput = $('[data-predictive-input]');
  const results = $('[data-predictive-results]');
  function closeSearch() { if (searchPanel && !searchPanel.hidden) searchPanel.hidden = true; }
  $$('[data-search-open]').forEach((b) => b.addEventListener('click', () => {
    if (!searchPanel) return;
    searchPanel.hidden = !searchPanel.hidden;
    if (!searchPanel.hidden) setTimeout(() => searchInput && searchInput.focus(), 30);
  }));
  $$('[data-search-close]').forEach((b) => b.addEventListener('click', closeSearch));
  document.addEventListener('click', (e) => {
    if (searchPanel && !searchPanel.hidden && !e.target.closest('[data-search-panel]') && !e.target.closest('[data-search-open]')) closeSearch();
  });
  let searchTimer, searchCtrl;
  searchInput && searchInput.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const q = searchInput.value.trim();
    if (q.length < 2) { results.innerHTML = ''; return; }
    searchTimer = setTimeout(async () => {
      try {
        searchCtrl && searchCtrl.abort();
        searchCtrl = new AbortController();
        const url = `${T.routes.predictive}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;
        const res = await fetch(url, { signal: searchCtrl.signal });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('.predictive__inner');
        results.innerHTML = inner ? inner.outerHTML : '';
      } catch (err) { /* afgebroken */ }
    }, 220);
  });

  /* ---------- Horizontale rijen met knoppen ---------- */
  $$('.reviews, .featured, .tiles').forEach((sec) => {
    const row = $('[data-scroll-row]', sec);
    if (!row) return;
    const step = () => (row.firstElementChild ? row.firstElementChild.getBoundingClientRect().width + 14 : 300);
    $$('[data-scroll-prev]', sec).forEach((b) => b.addEventListener('click', () => row.scrollBy({ left: -step(), behavior: 'smooth' })));
    $$('[data-scroll-next]', sec).forEach((b) => b.addEventListener('click', () => row.scrollBy({ left: step(), behavior: 'smooth' })));
  });

  /* ---------- Swatches op productkaarten ---------- */
  function bindCards(root) {
    $$('[data-card]', root).forEach((card) => {
      if (card.dataset.bound) return;
      card.dataset.bound = '1';
      const img = $('[data-card-img]', card);
      const links = $$('[data-card-link]', card);
      const apply = (dot) => {
        $$('.swatch-dot', card).forEach((d) => d.classList.toggle('is-active', d === dot));
        if (img && dot.dataset.img) {
          img.removeAttribute('srcset');
          if (dot.dataset.srcset) img.srcset = dot.dataset.srcset;
          img.src = dot.dataset.img;
        }
        if (dot.dataset.url) links.forEach((l) => (l.href = dot.dataset.url));
      };
      $$('.swatch-dot', card).forEach((dot) => {
        dot.addEventListener('click', (e) => { e.preventDefault(); apply(dot); });
        dot.addEventListener('mouseenter', () => { if (window.matchMedia('(hover: hover)').matches) apply(dot); });
      });
    });
  }
  bindCards(document);

  /* ---------- Winkelwagen ---------- */
  const drawerSection = () => document.getElementById('shopify-section-cart-drawer');
  const getDrawer = () => $('[data-cart-drawer]');
  let cartCount = parseInt(($('[data-cart-count]') || {}).textContent || '0', 10) || 0;

  function updateCount(count) {
    cartCount = count;
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.classList.toggle('is-empty', count === 0); });
    updateTierBoxes();
  }

  async function refreshDrawer(open) {
    try {
      const res = await fetch(`${T.routes.root}?sections=cart-drawer`);
      const data = await res.json();
      const html = data['cart-drawer'];
      const wasOpen = getDrawer() && getDrawer().classList.contains('is-open');
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-drawer]');
      const old = getDrawer();
      if (fresh && old) {
        old.replaceWith(fresh);
        if (wasOpen || open) { fresh.classList.add('is-open'); fresh.setAttribute('aria-hidden', 'false'); openLayer = fresh; }
        bindDrawer();
      }
      if (open && !wasOpen) openPanel(getDrawer());
      const cart = await (await fetch(`${T.routes.cart}.js`)).json();
      window.__cart = cart;
      updateCount(cart.item_count);
    } catch (err) { console.error(err); }
  }

  function setLoading(on) { const d = getDrawer(); d && d.classList.toggle('is-loading', on); }

  async function changeLine(key, quantity) {
    setLoading(true);
    try {
      await fetch(`${T.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    } finally { await refreshDrawer(); setLoading(false); }
  }

  async function loadDrawerRecs() {
    const box = $('[data-cart-recs]', getDrawer() || document);
    if (!box || box.dataset.loaded) return;
    box.dataset.loaded = '1';
    try {
      const res = await fetch(`${T.routes.recommendations}?section_id=cart-recommendations&product_id=${box.dataset.productId}&limit=8&intent=related`);
      if (!res.ok) return;
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const sec = doc.querySelector('.shopify-section') || doc.body;
      box.innerHTML = sec.innerHTML.trim();
    } catch (err) { /* geen aanbevelingen */ }
  }

  function bindDrawer() {
    const d = getDrawer();
    if (!d) return;
    $$('[data-cart-close]', d).forEach((b) => b.addEventListener('click', () => closePanel(d)));
    $$('[data-qty-change]', d).forEach((b) => b.addEventListener('click', () => {
      const li = b.closest('[data-line-key]');
      changeLine(li.dataset.lineKey, parseInt(b.dataset.qtyChange, 10));
    }));
    const prot = $('[data-protection]', d);
    prot && prot.addEventListener('change', async () => {
      setLoading(true);
      try {
        if (prot.checked) {
          await fetch(`${T.routes.cartAdd}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(prot.dataset.variant), quantity: 1 }] }) });
        } else if (prot.dataset.lineKey) {
          await fetch(`${T.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: prot.dataset.lineKey, quantity: 0 }) });
        }
      } finally { await refreshDrawer(); setLoading(false); }
    });
    loadDrawerRecs();
  }
  bindDrawer();

  $$('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => {
    if (!getDrawer()) return;
    e.preventDefault();
    openPanel(getDrawer());
    loadDrawerRecs();
  }));

  async function addToCart(form, button) {
    const errorEl = $('[data-form-error]', form);
    const textEl = button && $('[data-atc-text]', button);
    const original = textEl ? textEl.textContent : '';
    if (button) { button.disabled = true; if (textEl) textEl.textContent = T.strings.adding; }
    if (errorEl) errorEl.hidden = true;
    try {
      const fd = new FormData(form);
      const res = await fetch(`${T.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      await refreshDrawer(true);
      trackAddedToCart(data.items ? data.items[0] : data);
    } catch (err) {
      if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
    } finally {
      if (button) { button.disabled = false; if (textEl) textEl.textContent = original; }
    }
  }


  /* ---------- Snelkeuze: Toevoegen-knop op productkaarten ---------- */
  const qa = $('[data-qa]');
  let qaProduct = null;
  async function addItems(items) {
    const res = await fetch(`${T.routes.cartAdd}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
    return data;
  }
  function sizedImg(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    try { const u = new URL(src, location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return src; }
  }
  function closeQa() {
    if (!qa || qa.hidden) return;
    qa.classList.remove('is-open');
    document.body.classList.remove('qa-open');
    setTimeout(() => { qa.hidden = true; }, 200);
  }
  const qaFieldsets = () => $$('[data-qa-opt]', qa);
  function qaSelected() { return qaFieldsets().map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; }); }
  function qaFind(opts) { return qaProduct.variants.find((v) => v.options.every((o, i) => o === opts[i])); }
  function qaUpdate() {
    const opts = qaSelected();
    qaFieldsets().forEach((fs, i) => {
      const out = $('[data-qa-val]', fs); if (out) out.textContent = opts[i] || '';
      $$('input', fs).forEach((inp) => {
        const test = opts.slice(); test[i] = inp.value;
        const vv = qaFind(test);
        inp.classList.toggle('is-unavailable', !vv || !vv.available);
      });
    });
    const v = qaFind(opts);
    const btn = $('[data-qa-submit]', qa);
    if (!v) { btn.disabled = true; btn.textContent = T.strings.unavailable; return; }
    btn.disabled = !v.available;
    btn.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
    const priceEl = $('[data-qa-price]', qa);
    priceEl.textContent = '';
    const cur = document.createElement('span'); cur.className = 'price__current'; cur.textContent = formatMoney(v.price); priceEl.appendChild(cur);
    if (v.compare_at_price > v.price) { const s = document.createElement('s'); s.className = 'price__compare'; s.textContent = formatMoney(v.compare_at_price); priceEl.appendChild(s); }
    priceEl.classList.toggle('price--sale', v.compare_at_price > v.price);
    const src = (v.featured_image && v.featured_image.src) || qaProduct.featured_image;
    const box = $('[data-qa-img]', qa);
    if (src) { box.textContent = ''; const im = document.createElement('img'); im.src = sizedImg(src, 300); im.alt = ''; box.appendChild(im); }
  }
  function qaBuild(p, bogo) {
    qaProduct = p;
    $('[data-qa-title]', qa).textContent = p.title;
    $('[data-qa-link]', qa).href = p.url || `/products/${p.handle}`;
    const wrap = $('[data-qa-options]', qa);
    wrap.textContent = '';
    const first = p.variants.find((v) => v.available) || p.variants[0];
    const hasOptions = !(p.variants.length === 1 && /default title/i.test(p.variants[0].title));
    if (hasOptions) {
      p.options.forEach((opt, i) => {
        const name = typeof opt === 'string' ? opt : opt.name;
        const values = typeof opt === 'string' ? [...new Set(p.variants.map((v) => v.options[i]))] : opt.values;
        const lname = String(name).toLowerCase();
        const isColor = /^(kleur|color|colour|kolor)$/.test(lname);
        const fs = document.createElement('fieldset'); fs.className = 'opt'; fs.setAttribute('data-qa-opt', '');
        const lg = document.createElement('legend'); lg.className = 'opt__label';
        const sp = document.createElement('span'); sp.textContent = name + ': ';
        const b = document.createElement('strong'); b.setAttribute('data-qa-val', ''); sp.appendChild(b); lg.appendChild(sp); fs.appendChild(lg);
        const row = document.createElement('div'); row.className = 'opt__values' + (isColor ? ' opt__values--swatch' : '');
        values.forEach((val, k) => {
          const id = `qa-${i}-${k}`;
          const inp = document.createElement('input'); inp.type = 'radio'; inp.className = 'opt__input'; inp.name = `qa-opt-${i}`; inp.id = id; inp.value = val;
          if (first && first.options[i] === val) inp.checked = true;
          const lab = document.createElement('label'); lab.htmlFor = id; lab.title = val;
          const vimg = isColor ? p.variants.find((v) => v.options[i] === val && v.featured_image) : null;
          if (vimg) { lab.className = 'swatch'; const im = document.createElement('img'); im.src = sizedImg(vimg.featured_image.src, 120); im.alt = val; lab.appendChild(im); }
          else { lab.className = 'pill'; lab.textContent = val; }
          inp.addEventListener('change', qaUpdate);
          row.appendChild(inp); row.appendChild(lab);
        });
        fs.appendChild(row); wrap.appendChild(fs);
      });
    }
    const bogoBox = $('[data-qa-bogo]', qa);
    bogoBox.hidden = !bogo;
    if (bogo) { const two = $('input[value="2"]', bogoBox); if (two) two.checked = true; }
    $('[data-qa-error]', qa).hidden = true;
    if (!hasOptions) {
      const btn = $('[data-qa-submit]', qa);
      btn.disabled = !first.available;
      btn.textContent = first.available ? T.strings.addToCart : T.strings.soldOut;
      const priceEl = $('[data-qa-price]', qa); priceEl.textContent = formatMoney(first.price);
      const box = $('[data-qa-img]', qa); box.textContent = '';
      if (p.featured_image) { const im = document.createElement('img'); im.src = sizedImg(p.featured_image, 300); im.alt = ''; box.appendChild(im); }
    } else {
      qaUpdate();
    }
  }
  async function openQa(handle, bogo, trigger) {
    if (!qa) { window.location.href = `/products/${handle}`; return; }
    const original = trigger ? trigger.textContent : '';
    if (trigger) { trigger.disabled = true; trigger.textContent = T.strings.adding; }
    try {
      const root = (T.routes.root || '/').replace(/\/$/, '');
      const res = await fetch(`${root}/products/${encodeURIComponent(handle)}.js`);
      if (!res.ok) throw new Error('product');
      qaBuild(await res.json(), bogo);
      qa.hidden = false;
      document.body.classList.add('qa-open');
      requestAnimationFrame(() => qa.classList.add('is-open'));
      const c = $('[data-qa-close]', qa); c && c.focus();
    } catch (err) {
      window.location.href = `/products/${handle}`;
    } finally {
      if (trigger) { trigger.disabled = false; trigger.textContent = original; }
    }
  }
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const bogo = btn.hasAttribute('data-bogo');
    if (btn.dataset.variantId && !bogo) {
      const original = btn.textContent;
      btn.disabled = true; btn.textContent = T.strings.adding;
      try {
        const data = await addItems([{ id: Number(btn.dataset.variantId), quantity: 1 }]);
        await refreshDrawer(true);
        trackAddedToCart(data.items ? data.items[0] : data);
      } catch (err) { window.location.href = `/products/${btn.dataset.quickAdd}`; }
      finally { btn.disabled = false; btn.textContent = original; }
      return;
    }
    openQa(btn.dataset.quickAdd, bogo, btn);
  });
  if (qa) {
    $$('[data-qa-close]', qa).forEach((b) => b.addEventListener('click', closeQa));
    qa.addEventListener('click', (e) => { if (e.target === qa) closeQa(); });
    $('[data-qa-submit]', qa).addEventListener('click', async () => {
      if (!qaProduct) return;
      const opts = qaSelected();
      const v = qaFieldsets().length ? qaFind(opts) : (qaProduct.variants.find((x) => x.available) || qaProduct.variants[0]);
      if (!v || !v.available) return;
      const bogoBox = $('[data-qa-bogo]', qa);
      const r = !bogoBox.hidden && $('input:checked', bogoBox);
      const qty = r ? Number(r.value) || 1 : 1;
      const btn = $('[data-qa-submit]', qa);
      const err = $('[data-qa-error]', qa);
      btn.disabled = true; btn.textContent = T.strings.adding; err.hidden = true;
      try {
        const data = await addItems([{ id: v.id, quantity: qty }]);
        closeQa();
        await refreshDrawer(true);
        trackAddedToCart(data.items ? data.items[0] : data);
      } catch (x) {
        err.textContent = x.message; err.hidden = false;
      } finally { btn.disabled = false; btn.textContent = T.strings.addToCart; }
    });
  }

  /* ---------- Staffelkorting-blok ---------- */
  function productsInCart(prot) {
    const cart = window.__cart;
    if (!cart) return null;
    return cart.items
      .filter((i) => i.handle !== prot && !(T.hiddenHandles || []).includes(i.handle))
      .reduce((n, i) => n + i.quantity, 0);
  }
  function updateTierBoxes() {
    $$('[data-tierbox]').forEach((box) => {
      let tiers;
      try { tiers = JSON.parse(box.dataset.tiers); } catch (e) { return; }
      const price = Number(box.dataset.price) || 0;
      $$('[data-tier]', box).forEach((row) => {
        const pct = tiers[Number(row.dataset.tier)][1];
        const p = $('[data-tier-price]', row);
        if (p) p.textContent = formatMoney(Math.round((price * (100 - pct)) / 100));
      });
      const n = productsInCart(box.dataset.prot);
      if (n === null) return;
      let a = -1;
      tiers.forEach(([q], i) => { if (n + 1 >= q) a = i; });
      $$('[data-tier]', box).forEach((row) => row.classList.toggle('is-active', Number(row.dataset.tier) === a));
    });
  }
  if ($('[data-tierbox]')) {
    fetch(`${T.routes.cart}.js`).then((r) => r.json()).then((c) => { window.__cart = c; updateTierBoxes(); }).catch(() => {});
  }

  /* ---------- Productpagina ---------- */
  $$('[data-product]').forEach((root) => {
    const form = $('[data-product-form]', root);
    const variantsEl = $('[data-variants]', root);
    const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    const idInput = $('[data-variant-id]', root);
    const atc = $('[data-atc]', root);
    const atcText = $('[data-atc-text]', root);
    const badge = $('[data-pct-badge]', root);
    const track = $('[data-gallery-track]', root);
    const slides = track ? $$('.gallery__slide', track) : [];
    const thumbs = $$('[data-thumb]', root);
    const dots = $$('.gallery__dot', root);
    const sticky = $('[data-sticky-atc]', root);

    /* Galerij */
    function goTo(i, smooth = true) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    }
    /* Hoogte van de galerij volgt de verhouding van de actieve foto */
    function fitHeight(i) {
      const s = slides[i];
      if (!track || !s) return;
      const h = s.offsetHeight;
      if (h && track.style.height !== h + 'px') {
        track.style.height = h + 'px';
        track.classList.add('is-sized');
      }
    }
    function setActive(i) {
      fitHeight(i);
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      const at = thumbs[i];
      if (at && at.parentElement) {
        const p = at.parentElement;
        const l = at.offsetLeft - p.clientWidth / 2 + at.clientWidth / 2;
        p.scrollTo({ left: l, behavior: 'smooth' });
      }
    }
    let scrollTimer;
    track && track.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => setActive(Math.round(track.scrollLeft / track.clientWidth)), 60);
    }, { passive: true });
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(parseInt(t.dataset.thumb, 10))));
    const current = () => (track ? Math.round(track.scrollLeft / track.clientWidth) : 0);
    if (track && slides.length) {
      fitHeight(current());
      if ('ResizeObserver' in window) new ResizeObserver(() => fitHeight(current())).observe(slides[0]);
      else window.addEventListener('resize', () => fitHeight(current()));
    }
    $('[data-gallery-prev]', root) && $('[data-gallery-prev]', root).addEventListener('click', () => goTo(Math.max(0, current() - 1)));
    $('[data-gallery-next]', root) && $('[data-gallery-next]', root).addEventListener('click', () => goTo(Math.min(slides.length - 1, current() + 1)));
    // Startpositie op variantfoto
    if (idInput) {
      const v0 = variants.find((v) => v.id === Number(idInput.value));
      if (v0 && v0.media) {
        const idx = slides.findIndex((s) => Number(s.dataset.mediaId) === v0.media);
        if (idx > 0) requestAnimationFrame(() => { goTo(idx, false); setActive(idx); });
      }
    }

    /* Varianten */
    const fieldsets = $$('[data-option-index]', root);
    function selectedOptions() {
      return fieldsets.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
    }
    function findVariant(opts) {
      if (!fieldsets.length) return variants[0];
      return variants.find((v) => v.options.every((o, i) => o === opts[i]));
    }
    function markAvailability(opts) {
      fieldsets.forEach((fs, i) => {
        $$('input', fs).forEach((inp) => {
          const test = opts.slice(); test[i] = inp.value;
          const v = variants.find((x) => x.options.every((o, k) => o === test[k]));
          inp.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function update() {
      const opts = selectedOptions();
      fieldsets.forEach((fs, i) => { const out = $('[data-option-value]', fs); if (out) out.textContent = opts[i] || ''; });
      markAvailability(opts);
      const v = findVariant(opts);
      if (!v) {
        if (atc) atc.disabled = true;
        if (atcText) atcText.textContent = T.strings.unavailable;
        return;
      }
      if (idInput) idInput.value = v.id;
      const tbox = $('[data-tierbox]', root);
      if (tbox) { tbox.dataset.price = v.price; updateTierBoxes(); }
      if (atc) atc.disabled = !v.available;
      if (atcText) atcText.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      const priceEl = $('[data-price]', root);
      if (priceEl) {
        const cur = $('[data-current-price]', priceEl);
        let cmp = $('[data-compare-price]', priceEl);
        if (cur) cur.textContent = formatMoney(v.price);
        if (v.compare > v.price) {
          if (!cmp) { cmp = document.createElement('s'); cmp.className = 'price__compare'; cmp.setAttribute('data-compare-price', ''); priceEl.append(cmp); }
          cmp.textContent = formatMoney(v.compare);
          priceEl.classList.add('price--sale');
        } else if (cmp) { cmp.remove(); priceEl.classList.remove('price--sale'); }
      }
      if (badge) {
        const pct = v.compare > v.price ? Math.floor(((v.compare - v.price) * 100) / v.compare) : 0;
        badge.textContent = badge.textContent.replace(/\d+/, pct);
        badge.classList.toggle('is-hidden', pct === 0);
      }
      if (v.media) {
        const idx = slides.findIndex((s) => Number(s.dataset.mediaId) === v.media);
        if (idx >= 0) goTo(idx);
        const simg = $('[data-sticky-img]', root);
        const slideImg = slides[idx] && $('img', slides[idx]);
        if (simg && slideImg) { simg.removeAttribute('srcset'); simg.src = slideImg.currentSrc || slideImg.src; }
      }
      if (sticky) {
        const sv = $('[data-sticky-variant]', sticky); if (sv) sv.textContent = opts.filter(Boolean).join(' / ');
        const sp = $('[data-sticky-price]', sticky); if (sp) sp.textContent = formatMoney(v.price);
        const sb = $('[data-sticky-btn]', sticky); if (sb) sb.disabled = !v.available;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    fieldsets.forEach((fs) => $$('input', fs).forEach((inp) => inp.addEventListener('change', update)));
    if (fieldsets.length) markAvailability(selectedOptions());

    form && form.addEventListener('submit', (e) => { e.preventDefault(); addToCart(form, atc); });

    /* Sticky koopbalk */
    if (sticky && atc && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
      io.observe(atc);
      const sb = $('[data-sticky-btn]', sticky);
      sb && sb.addEventListener('click', () => addToCart(form, atc));
    }
  });

  /* ---------- Modals ---------- */
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-modal-open]');
    if (opener) { const m = document.getElementById(opener.dataset.modalOpen); if (m) { m.hidden = false; const c = $('[data-modal-close]', m); c && c.focus(); } return; }
    const closer = e.target.closest('[data-modal-close]');
    if (closer) { closer.closest('[data-modal]').hidden = true; return; }
    if (e.target.matches('[data-modal]')) e.target.hidden = true;
  });

  /* ---------- Aanbevelingen (productpagina) ---------- */
  $$('[data-recommendations]').forEach(async (sec) => {
    if (sec.children.length) return;
    try {
      const res = await fetch(sec.dataset.url);
      if (!res.ok) { sec.remove(); return; }
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) { sec.innerHTML = fresh.innerHTML; bindCards(sec); }
      else sec.remove();
    } catch (err) { sec.remove(); }
  });

  /* ---------- Collectie: filters, sorteren, meer laden ---------- */
  const filterForm = $('[data-filter-form]');
  const filters = $('[data-filters]');
  $$('[data-filters-open]').forEach((b) => b.addEventListener('click', () => openPanel(filters)));
  $$('[data-filters-close]').forEach((b) => b.addEventListener('click', () => closePanel(filters)));
  function submitFilters() {
    const fd = new FormData(filterForm);
    const params = new URLSearchParams();
    for (const [k, v] of fd.entries()) { if (v !== '') params.append(k, v); }
    window.location.search = params.toString();
  }
  if (filterForm) {
    filterForm.addEventListener('submit', (e) => { e.preventDefault(); submitFilters(); });
    $$('[data-autosubmit]', filterForm).forEach((el) => el.addEventListener('change', submitFilters));
  }
  $$('[data-load-more]').forEach((btn) => btn.addEventListener('click', async (e) => {
    e.preventDefault();
    const grid = $('[data-grid]');
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(btn.href);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const items = $$('[data-grid] > *', doc);
      items.forEach((el) => grid.appendChild(el));
      bindCards(grid);
      const nextBtn = $('[data-load-more]', doc);
      const count = $('[data-loadmore-count]', doc);
      const myCount = $('[data-loadmore-count]');
      if (count && myCount) myCount.textContent = count.textContent;
      if (nextBtn) btn.href = nextBtn.href; else btn.closest('.loadmore').remove();
    } catch (err) { window.location.href = btn.href; }
    btn.classList.remove('is-loading');
    btn.removeAttribute('aria-busy');
  }));
  /* ---------- Klaviyo (alleen na toestemming voor marketingcookies) ---------- */
  let klaviyoLoaded = false;
  function kTrack(name, props) {
    if (!klaviyoLoaded || !window.klaviyo) return;
    try { window.klaviyo.push(['track', name, props]); } catch (e) { /* stil */ }
  }
  function readJson(sel) {
    const el = $(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function loadKlaviyo() {
    if (klaviyoLoaded || !T.klaviyoKey || (window.Shopify && window.Shopify.designMode)) return;
    klaviyoLoaded = true;
    /* Officiële Klaviyo-object proxy, zodat calls vóór het laden in de wachtrij komen */
    !function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();
    /* Niet dubbel laden als de Klaviyo-app-embed toch aan staat */
    if (!document.querySelector('script[src*="static.klaviyo.com/onsite/js/"]')) {
      const sc = document.createElement('script');
      sc.async = true;
      sc.src = 'https://static.klaviyo.com/onsite/js/' + encodeURIComponent(T.klaviyoKey) + '/klaviyo.js';
      document.head.appendChild(sc);
    }
    /* Ingelogde klant herkennen */
    if (T.customerEmail) {
      try { window.klaviyo.push(['identify', { email: T.customerEmail }]); } catch (e) { /* stil */ }
    }
    const col = readJson('[data-collection-track]');
    if (col) kTrack('Viewed Collection', col);
    const prod = readJson('[data-product-track]');
    if (prod) {
      kTrack('Viewed Product', prod);
      try {
        window.klaviyo.push(['trackViewedItem', { Title: prod.ProductName, ItemId: prod.ProductID, Categories: prod.Categories, ImageUrl: prod.ImageURL, Url: prod.URL, Metadata: { Brand: prod.Brand, Price: prod.Price, CompareAtPrice: prod.CompareAtPrice } }]);
      } catch (e) { /* stil */ }
    }
  }
  function trackAddedToCart(item) {
    if (!klaviyoLoaded || !item || !item.product_title) return;
    const abs = (u) => (u && u.indexOf('//') === 0 ? 'https:' + u : (u && u[0] === '/' ? location.origin + u : u || ''));
    const img = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
    const cart = window.__cart || { items: [] };
    kTrack('Added to Cart', {
      $value: (item.final_line_price || item.final_price * item.quantity || 0) / 100,
      ProductName: item.product_title,
      ProductID: item.product_id,
      'Variant Name': item.variant_title || '',
      SKU: item.sku || '',
      ImageURL: abs(img),
      URL: location.origin + '/products/' + item.handle,
      Price: (item.final_price || 0) / 100,
      Quantity: item.quantity,
      ItemNames: cart.items.map((i) => i.product_title),
      CheckoutURL: location.origin + '/cart'
    });
  }
  window.vsmLoadKlaviyo = loadKlaviyo;
  document.addEventListener('visitorConsentCollected', (e) => {
    const d = (e && e.detail) || {};
    if (d.marketingAllowed) loadKlaviyo();
  });

  /* ---------- Cookiebalk ---------- */
  (function cookieBanner() {
    const bar = $('[data-cookie-banner]');
    if (!bar) {
      /* Geen eigen cookiebalk: Klaviyo laden zodra Shopify's toestemming dat toestaat */
      const check = () => {
        const cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed()) loadKlaviyo();
      };
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], check);
      } else { check(); }
      return;
    }
    const prefs = $('[data-cookie-prefs]', bar);
    const toggleBtn = $('[data-cookie-toggle]', bar);
    const kinds = $$('[data-cookie-kind]', bar);
    const KEY = 'vsm_cookie_consent';
    const api = () => (window.Shopify && window.Shopify.customerPrivacy) || null;
    const stored = () => { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } };
    function current() {
      const cp = api();
      if (cp && typeof cp.currentVisitorConsent === 'function') {
        const v = cp.currentVisitorConsent() || {};
        const keys = ['analytics', 'marketing', 'preferences'];
        return {
          analytics: v.analytics === 'yes', marketing: v.marketing === 'yes', preferences: v.preferences === 'yes',
          decided: keys.every((k) => v[k] === 'yes' || v[k] === 'no') || !!stored()
        };
      }
      const s = stored();
      return s ? Object.assign({}, s, { decided: true }) : { analytics: false, marketing: false, preferences: false, decided: false };
    }
    function setPrefs(open) {
      prefs.hidden = !open;
      toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { const c = current(); kinds.forEach((k) => { k.checked = !!c[k.dataset.cookieKind]; }); }
    }
    function show(withPrefs) {
      bar.hidden = false;
      setPrefs(!!withPrefs);
      requestAnimationFrame(() => requestAnimationFrame(() => bar.classList.add('is-visible')));
    }
    function hide() {
      bar.classList.remove('is-visible');
      setTimeout(() => { bar.hidden = true; }, 380);
    }
    function save(c) {
      try { localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) { /* geen opslag */ }
      if (c.marketing) loadKlaviyo();
      const cp = api();
      if (cp && typeof cp.setTrackingConsent === 'function') {
        try { cp.setTrackingConsent({ analytics: c.analytics, marketing: c.marketing, preferences: c.preferences, sale_of_data: c.marketing }, () => {}); } catch (e) { /* stil */ }
      }
      hide();
    }
    $('[data-cookie-accept]', bar).addEventListener('click', () => save({ analytics: true, marketing: true, preferences: true }));
    $('[data-cookie-reject]', bar).addEventListener('click', () => save({ analytics: false, marketing: false, preferences: false }));
    $('[data-cookie-save]', bar).addEventListener('click', () => {
      const c = {};
      kinds.forEach((k) => { c[k.dataset.cookieKind] = k.checked; });
      save(c);
    });
    toggleBtn.addEventListener('click', () => setPrefs(prefs.hidden));
    $$('[data-cookie-open]').forEach((b) => b.addEventListener('click', () => show(true)));

    const nativeVisible = () => {
      const nb = document.getElementById('shopify-pc__banner');
      return !!(nb && nb.offsetParent !== null);
    };
    function maybeShow() {
      if (window.Shopify && window.Shopify.designMode) { show(false); return; }
      const cpx = api();
      if (current().marketing || (cpx && typeof cpx.marketingAllowed === 'function' && cpx.marketingAllowed())) loadKlaviyo();
      setTimeout(() => {
        if (nativeVisible()) return; // Shopify's eigen banner staat nog aan
        if (!current().decided) show(false);
      }, 900);
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => maybeShow());
    } else {
      maybeShow();
    }
  })();
  /* ---------- Inschrijf-popup (Klaviyo) ---------- */
  (function newsletterPopup() {
    const pop = $('[data-popup]');
    if (!pop) return;
    const store = {
      get: (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } },
      set: (k, v) => { try { localStorage.setItem(k, v); } catch (e) { /* stil */ } }
    };
    const forced = /[?&]popup=1/.test(location.search);
    const closedAt = Number(store.get('vsm_popup_closed') || 0);
    const days = Number(pop.dataset.days || 7);
    if (!forced) {
      if (window.Shopify && window.Shopify.designMode) return;
      if (store.get('vsm_popup_done')) return;
      if (closedAt && Date.now() - closedAt < days * 864e5) return;
      if (/\/(cart|checkouts?|account)/.test(location.pathname)) return;
    }
    let shown = false;
    function open() {
      if (shown) return;
      const bar = $('[data-cookie-banner]');
      if (bar && !bar.hidden && !forced) { setTimeout(open, 3000); return; }
      shown = true;
      pop.hidden = false;
      requestAnimationFrame(() => requestAnimationFrame(() => pop.classList.add('is-open')));
      document.body.classList.add('popup-open');
    }
    function close() {
      pop.classList.remove('is-open');
      document.body.classList.remove('popup-open');
      setTimeout(() => { pop.hidden = true; }, 300);
      if (!store.get('vsm_popup_done')) store.set('vsm_popup_closed', String(Date.now()));
    }
    setTimeout(open, forced ? 300 : (Number(pop.dataset.delay) || 8) * 1000);
    document.addEventListener('mouseout', (e) => {
      if (!e.relatedTarget && e.clientY <= 0 && window.matchMedia('(hover: hover)').matches) open();
    });
    $$('[data-popup-close]', pop).forEach((b) => b.addEventListener('click', close));
    pop.addEventListener('click', (e) => { if (e.target === pop) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !pop.hidden) close(); });

    const form = $('[data-popup-form]', pop);
    const err = $('[data-popup-error]', pop);
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = (form.email.value || '').trim();
      err.hidden = true;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = T.strings.popupInvalid; err.hidden = false; return; }
      const btn = $('button[type="submit"]', form);
      btn.disabled = true;
      try {
        const res = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(pop.dataset.key), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-10-15' },
          body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Popup Van Straaten Mode', profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: pop.dataset.list } } } } })
        });
        if (!res.ok) throw new Error(String(res.status));
        store.set('vsm_popup_done', '1');
        $('[data-popup-step="form"]', pop).hidden = true;
        $('[data-popup-step="done"]', pop).hidden = false;
        if (klaviyoLoaded && window.klaviyo && typeof window.klaviyo.identify === 'function') {
          try { window.klaviyo.identify({ email: email }); } catch (x) { /* stil */ }
        }
      } catch (x) {
        err.textContent = T.strings.popupError; err.hidden = false;
      } finally { btn.disabled = false; }
    });
    const copy = $('[data-popup-copy]', pop);
    copy && copy.addEventListener('click', async () => {
      try { await navigator.clipboard.writeText(copy.dataset.code); } catch (x) { /* stil */ }
      const l = $('[data-popup-copy-label]', copy); if (l) l.textContent = T.strings.popupCopied;
    });
  })();

  /* ---------- Feedbackpagina: beoordeling en bestelling uit de URL ---------- */
  (function feedbackPrefill() {
    const box = $('[data-feedback]');
    if (!box) return;
    const q = new URLSearchParams(location.search);
    const r = parseInt(q.get('beoordeling') || q.get('ocena') || '', 10);
    if (r >= 1 && r <= 5) { const i = $('[data-star="' + r + '"]', box); if (i) i.checked = true; }
    const o = q.get('bestelling') || q.get('zamowienie');
    const oi = $('[data-feedback-order]', box);
    if (o && oi) oi.value = o.slice(0, 40);
  })();
})();
